import Vue from 'vue'
import VuePageTransition from 'vue-page-transition'
import {Plugin} from 'vue-fragment'
import axios from 'axios'
import VueAxios from 'vue-axios'

import store from './Store/index'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router/index"
import '@mdi/font/css/materialdesignicons.css'
import './styles/globalStyle.css'

Vue.config.productionTip = false
Vue.use(VuePageTransition)
Vue.use(Plugin)
Vue.use(VueAxios,axios)

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
